import apiClient from './api';

export type ServiceProcessUploadRequirement = 'none' | 'image' | 'video' | 'image_video';

export interface ServiceProcessStep {
  id: string;
  categoryId?: string;
  name: string;
  description: string;
  sort: number;
  uploadRequirement: ServiceProcessUploadRequirement;
  allowRemark: boolean;
  mustCompleteBeforeNext: boolean;
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServiceProcessConfig {
  categoryId: string;
  steps: ServiceProcessStep[];
}

export interface SaveServiceProcessConfigRequest {
  steps: ServiceProcessStep[];
}

export const getServiceProcessConfig = async (categoryId: string): Promise<ServiceProcessConfig> => {
  const response = await apiClient.get<ServiceProcessConfig>('/service-process-config', {
    params: { categoryId },
  });
  return {
    categoryId,
    steps: response.data?.steps || [],
  };
};

export const saveServiceProcessConfig = async (
  categoryId: string,
  data: SaveServiceProcessConfigRequest,
): Promise<ServiceProcessConfig> => {
  const response = await apiClient.put<ServiceProcessConfig>('/service-process-config', data, {
    params: { categoryId },
  });
  return {
    categoryId,
    steps: response.data?.steps || [],
  };
};
